const tables = [
  {
    name: "Name",
  },
  {
    name: "Item Code",
  },
  {
    name: "Unit",
  },
  {
    name: "Category",
  },
  {
    name: "Brand",
  },
  {
    name: "Stock",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
